import { useRef, useEffect, useState } from 'react';

export default function Carousel({ children }) {
  const ref = useRef(null);

  const [leftArrowVisible, setLeftArrowVisible] = useState(false);
  const [rightArrowVisible, setRightArrowVisible] = useState(true);

  useEffect(() => {
    const listenToScroll = () => {
      setLeftArrowVisible(ref.current.scrollLeft !== 0);
      setRightArrowVisible(
        ref.current.scrollLeft < ref.current.scrollWidth - window.innerWidth,
      );
    };

    const curRef = ref.current;
    curRef.addEventListener('scroll', listenToScroll);
    return () => curRef.removeEventListener('scroll', listenToScroll);
  }, []);

  const scroll = isLeft => {
    let scrollOffset = 0;
    const windowWidth = window.innerWidth;
    if (windowWidth < 640) scrollOffset = windowWidth * (10 / 12);
    else scrollOffset = 320;
    if (isLeft) scrollOffset = 0 - scrollOffset;
    ref.current.scrollLeft += scrollOffset;
  };

  let arrowColor =
    'tw-stroke-primary-400 hover:tw-stroke-primary-500 dark:tw-stroke-primary-700 dark:hover:tw-stroke-primary-500 hover:tw-border-primary-500 hover:tw-bg-primary-100 active:tw-bg-primary-200 dark:hover:tw-bg-primary-900 dark:active:tw-bg-primary-800 tw-bg-black/5 dark:tw-bg-white/20';
  if (rightArrowVisible && !leftArrowVisible) {
    arrowColor =
      'tw-stroke-primary-500 hover:tw-border-primary-500 tw-bg-primary-100 dark:tw-bg-primary-900 hover:tw-bg-primary-100 active:tw-bg-primary-200 dark:hover:tw-bg-primary-900 dark:active:tw-bg-primary-800';
  }

  return (
    <div className="print:tw-hidden tw-full">
      {rightArrowVisible && (
        <div className="tw-absolute tw-right-1 tw-z-50 tw-mt-[7.5rem] tw-py-2 tw-pl-2">
          <button onClick={() => scroll(false)} className="twbtn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={
                'tw-h-12 tw-w-12 tw-rounded-full tw-border-2 tw-border-transparent tw-pl-1 tw-opacity-80 hover:tw-opacity-100 ' +
                arrowColor
              }
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
              />
            </svg>
          </button>
        </div>
      )}
      {leftArrowVisible && (
        <div className="tw-absolute tw-left-1 tw-z-10 tw-mt-[7.5rem] tw-py-2 tw-pr-2">
          <button onClick={() => scroll(true)} className="twbtn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={
                'tw-h-12 tw-w-12 tw-rounded-full tw-border-2 tw-border-transparent tw-pr-1 tw-opacity-80 hover:tw-opacity-100 ' +
                arrowColor
              }
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 19.5L8.25 12l7.5-7.5"
              />
            </svg>
          </button>
        </div>
      )}
      <div
        className={`no-scrollbar smooth-scroll tw-flex tw-snap-x tw-snap-mandatory tw-flex-nowrap tw-overflow-x-auto tw-space-x-2 tw-full`}
        ref={ref}
      >
        {children}
      </div>
    </div>
  );
}
